import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../lib/cn.js';
export function Card({ children, className }) {
    return (_jsx("section", { className: cn('rounded-[var(--radius-surface)] bg-surface shadow-[var(--shadow-card)]', className), children: children }));
}
export function CardHeader({ title, description, actions, className }) {
    return (_jsxs("header", { className: cn('flex items-start justify-between gap-4 border-b border-border px-6 py-5', className), children: [_jsxs("div", { children: [_jsx("h2", { className: "text-lg font-semibold text-content", children: title }), description === undefined ? null : (_jsx("p", { className: "mt-0.5 text-sm text-content-muted", children: description }))] }), actions === undefined ? null : _jsx("div", { className: "flex shrink-0 gap-2", children: actions })] }));
}
export function CardBody({ children, className }) {
    return _jsx("div", { className: cn('px-6 py-5', className), children: children });
}
export function CardFooter({ children, className }) {
    return _jsx("footer", { className: cn('border-t border-border px-6 py-4', className), children: children });
}
//# sourceMappingURL=card.js.map